var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 530,
    height: 530,
    viewBox: "0 0 530 530",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 281.5,
    cy: 267.5,
    r: 164.5,
    fill: "#F9F9F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M236.284 134.774V74H273.354V142.701C273.354 177.227 289.83 173.528 298.068 167.363C322.076 146.928 353.674 160.61 365.148 167.363C458.707 218.448 421.559 342.637 362.5 378.749C303.187 420.322 237.755 391.961 212.453 372.584C193.388 353.559 181.561 368.767 178.031 378.749V436H140.077V372.584C137.959 313.396 179.796 312.691 200.979 319.737C249.7 331.716 269.53 295.956 273.354 276.579C283.24 246.985 269.235 225.494 260.998 218.448C239.108 202.241 235.401 155.912 236.284 134.774Z",
    fill: "white",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M330.547 180.042C313.544 179.241 297.989 190.053 292.563 207.073C284.551 232.206 309.466 238.836 319.183 231.882C319.849 231.406 320.583 230.938 321.37 230.713C351.861 222 346.414 297.628 315.172 331.719C284.876 358.751 321.369 385.524 348.5 365.5C391 332.5 393.349 288.194 393.5 264.5C391.33 194.418 350.443 180.979 330.547 180.042Z",
    fill: "#F9F9F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNone);
export default __webpack_public_path__ + "static/media/내과_none.de3cd4ccc01b8a496c23ccb9b1f9f0ef.svg";
export { ForwardRef as ReactComponent };